"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Import = void 0;

var Import =
/** @class */
function () {
  function Import() {}

  Import.prototype.ImportColumnHeaderType = function () {
    return [{
      slug: 'address1',
      name: 'Address 1',
      description: null,
      isAddress1: true,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'address2',
      name: 'Address 2',
      description: null,
      isAddress1: false,
      isAddress2: true,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'arrivalAlert',
      name: 'Arrival Alert',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: true,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'checkInNotes',
      name: 'Check In Notes',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: true,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'city',
      name: 'City',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: true,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'company',
      name: 'Company',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: true,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'country',
      name: 'Country',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: true,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'email',
      name: 'Email',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: true,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'firstName',
      name: 'First Name',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: true,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'ignored',
      name: 'Ignored',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: true,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'invitationNotes',
      name: 'Invitation Notes',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: true,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'lastName',
      name: 'Last Name',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: true,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'other',
      name: 'Other',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: true,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'position',
      name: 'Position',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: true,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'postalCode',
      name: 'Postal Code',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: true,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'quantity',
      name: 'Quantity',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: true,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'state',
      name: 'State',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: true,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'telephone',
      name: 'Mobile Phone',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: true,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'ticketStatus',
      name: 'Ticket Status',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: true,
      isTicketType: false,
      isTitle: false
    }, {
      slug: 'ticketType',
      name: 'Access Type',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: true,
      isTitle: false
    }, {
      slug: 'title',
      name: 'Title',
      description: null,
      isAddress1: false,
      isAddress2: false,
      isArrivalAlert: false,
      isCheckInNotes: false,
      isCity: false,
      isCompany: false,
      isCountry: false,
      isEmail: false,
      isFirstName: false,
      isIgnored: false,
      isInvitationNotes: false,
      isLastName: false,
      isOther: false,
      isPosition: false,
      isPostalCode: false,
      isQuantity: false,
      isState: false,
      isTelephone: false,
      isTicketStatus: false,
      isTicketType: false,
      isTitle: true
    }];
  };

  return Import;
}();

exports.Import = Import;